export const DAYTIME_RUNNING_LIGHTS = 65;
export const ADAPTIVE_LIGHTING = 119;
export const FOG_LAMP = 76;
export const LED_HEADLIGHTS = 90;
export const XENON_HEADLIGHTS = 1;
export const LIGHT_SENSOR = 48;
export const HIGH_BEAM_ASSISTANT = 83;
export const HAS_DIMMING_INTERIOR_MIRROR = 'hasDimmingInteriorMirror';
export const HAS_HEATED_WIND_SHIELD = 'hasHeatedWindShield';
